(() => {
  const carousels = document.querySelectorAll(
    '[data-centra-articles-carousel]'
  );

  if (!carousels.length) return;

  carousels.forEach((carousel) => {
    const section = carousel.closest('.centra-related-articles');

    if (!section) return;

    const slider = section.querySelector(
      '[data-centra-articles-slider]'
    );

    const thumb = section.querySelector(
      '[data-centra-articles-slider-thumb]'
    );

    if (!slider || !thumb) return;

    const updateSlider = () => {
      const maxScroll =
        carousel.scrollWidth - carousel.clientWidth;

      /* No horizontal overflow */
      if (maxScroll <= 0) {
        slider.style.display = 'none';
        return;
      }

      /* Horizontal overflow exists */
      slider.style.display = '';

      const visibleRatio =
        carousel.clientWidth / carousel.scrollWidth;

      const thumbWidth =
        Math.max(visibleRatio * 100, 10);

      const maxThumbTravel =
        100 - thumbWidth;

      const scrollProgress =
        carousel.scrollLeft / maxScroll;

      thumb.style.width = `${thumbWidth}%`;

      thumb.style.transform =
        `translateX(${scrollProgress * maxThumbTravel}%)`;
    };

    carousel.addEventListener(
      'scroll',
      updateSlider,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      updateSlider
    );

    updateSlider();
  });
})();

